/**
 * Owner: Masa Bayu
 * File: QxBottomNav.tsx
 * Date:Time: 2026-10-22 14:10
 * Description: §461 — SATU bar navigasi bawah untuk semua halaman yang
 *   memakainya. Reka bentuk diambil daripada bar dashboard author mudah alih
 *   (§390, dahulu .qxpm__bottom): butang ikon + label sebaris grid, tanpa FAB.
 *   Dipakai oleh home landing (dahulu .qxl__tabbar) dan dashboard author
 *   private mudah alih. Hanya nampak <768px.
 *   §462 — item boleh bawa `expanded` (loceng home membuka sheet dalam bar).
 */

import type { ReactElement } from 'react';
import { LandingIcon } from '../home/marketplace/landing/LandingIcons';
import type { LandingIconName } from '../home/marketplace/landing/LandingIcons';
import './qx-bottom-nav.css';

export interface QxBottomNavItem {
  readonly id: string;
  readonly icon: LandingIconName;
  readonly label: string;
  readonly active?: boolean | undefined;
  readonly badge?: number | undefined;
  readonly expanded?: boolean | undefined;
  readonly onSelect: () => void;
}

export interface QxBottomNavProps {
  readonly ariaLabel: string;
  readonly items: readonly QxBottomNavItem[];
}

export function QxBottomNav({ ariaLabel, items }: QxBottomNavProps): ReactElement {
  return (
    <nav className="qx-bnav" aria-label={ariaLabel}>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          className={item.active === true ? 'qx-bnav__tab qx-bnav__tab--on' : 'qx-bnav__tab'}
          aria-current={item.active === true ? 'page' : undefined}
          aria-expanded={item.expanded}
          onClick={item.onSelect}
        >
          <LandingIcon name={item.icon} size={21} />
          <span>{item.label}</span>
          {item.badge !== undefined && item.badge > 0 ? (
            <em className="qx-bnav__badge" aria-hidden="true">
              {item.badge}
            </em>
          ) : null}
        </button>
      ))}
    </nav>
  );
}
